<app-loading-wrapper [loading]="!ready">
    <div class="mat-elevation-z0 table-responsive">
        <div *ngIf="!clientSortAndPage">
            <ng-container *ngTemplateOutlet="paginator"></ng-container>
        </div>
        <div class="table-wrapper">
            <mat-table [dataSource]="dataSource"
                       matSort (matSortChange)="onSort($event)">
                <ng-container *ngFor="let column of filteredColumns" matColumnDef="{{column.property}}">
                    <mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            [disabled]="(column.disableSort || column?.actions?.length > 0)">
                        <app-table-header [column]="column"></app-table-header>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"
                              [ngClass]="createCellCss(column)">
                        <app-table-cell
                                [column]="column"
                                [element]="element"
                                (elementUpdateEvent)="updateFromCell($event)">
                        </app-table-cell>
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                <div *matNoDataRow class="no-data-row"><div>No data found</div></div>
            </mat-table>
        </div>
        <ng-container *ngTemplateOutlet="paginator"></ng-container>
    </div>
</app-loading-wrapper>


<ng-template #paginator>
    <div class="margin-bottom-md margin-top-md">
        <mat-paginator
                (page)="onPage($event)"
                [pageSizeOptions]="pageSizeOptions"
                showFirstLastButtons
                [attr.aria-label]="pageLabel"></mat-paginator>
    </div>
</ng-template>